"use client";

// packages/eden-alert/src/components/Info.jsx
import { InfoFilled as InfoIcon } from "@churchofjesuschrist/eden-icons";
import { accentColorInfo } from "@churchofjesuschrist/eden-style-constants";
import Alert from './Alert.js';
import { jsx } from "react/jsx-runtime";
var Info = ({ children, title, renderTitleAs = "h2", ...props }) => /* @__PURE__ */ jsx(
  Alert,
  {
    ...props,
    color: accentColorInfo,
    Icon: InfoIcon,
    title,
    renderTitleAs,
    children
  }
);
Info.displayName = "Info";
var Info_default = Info;
export {
  Info_default as default
};
